import { Color } from "../../theme/Color";

export interface ButtonProps {
  color?: "primary" | "secondary" | "danger" | "success" | "alert" | "disabled";
  size?: "tiny" | "small" | "medium" | "large" | "extra-large" | "full-width";
  label: string;
  icon?: JSX.Element;
  showThrobber?: boolean;
  dataCy?: string;
  onClick?: any;
  id?: string;
  [x: string]: any;
  badgeCount?: number;
}

export const handleSize = (size) => {
  switch (size) {
    case "tiny":
      return `
          margin: 1rem;
          padding: 0.5rem 1rem;
          font-size: 1.4rem;
        `;
    case "small":
      return `
          margin: 1rem;
          padding: 1rem 1.25rem;
          font-size: 1.4rem;
        `;
    case "medium":
    case "default":
      return `
          margin: 1rem 0;
          padding: 1rem 4rem;
          font-size: 1.6rem;
        `;
    case "large":
      return `
          width: 100%;
          max-width: 50rem;
          margin: 1rem 0;
          padding: 1rem;
          font-size: 1.8rem;
        `;
    case "extra-large":
      return `
          width: 100%;
          max-width: 50rem;
          margin: 1rem 0;
          padding: 1.5rem 2rem;
          font-size: 2rem;
        `;
    case "full-width":
      return `
          width: 100%;
          max-width: 50rem;
          margin: 1rem 0;
          padding: 1rem 0.5rem;
        `;
  }
};

export const handleColor = (color) => {
  switch (color) {
    case "secondary":
      return `
        color: ${Color.White};
        box-shadow: ${Color.BlackShadow} 0 0.5rem 2rem 0;
        background-image: linear-gradient(to right, ${Color.Blue6} 0%, ${Color.Blue5} 100%);
  
        &:hover {
          background-image: linear-gradient(to right, ${Color.Blue5} 0%, ${Color.Blue5} 100%);
        }`;
    case "danger":
      return `
            color: ${Color.White};
            box-shadow: ${Color.BlackShadow} 0 0.5rem 2rem 0;
            background-image: linear-gradient(to right, ${Color.Red3} 0%, ${Color.Red3} 100%);
      
            &:hover {
              background-image: linear-gradient(to right, ${Color.Red3} 0%, ${Color.Red3} 100%);
            }`;
    case "success":
      return `
            color: ${Color.White};
            box-shadow: ${Color.BlackShadow} 0 0.5rem 2rem 0;
            background-image: linear-gradient(to right, ${Color.Green3} 0%, ${Color.Green3} 100%);
      
            &:hover {
              background-image: linear-gradient(to right, ${Color.Green3} 0%, ${Color.Green3} 100%);
            }`;
    case "alert":
      return `
                    color: ${Color.Black};
                    box-shadow: ${Color.BlackShadow} 0 0.5rem 2rem 0;
                    background-image: linear-gradient(to right, ${Color.Yellow3} 0%, ${Color.Yellow3} 100%);
              
                    &:hover {
                      background-image: linear-gradient(to right, ${Color.Yellow3} 0%, ${Color.Yellow3} 100%);
                    }`;
    case "disabled":
      return `
                    color: ${Color.Grey3};
                    box-shadow: none;
                    background: ${Color.Grey7};
              
                    &:hover {
                    background: ${Color.Grey6};
                    }`;
    default:
      return `
        color: ${Color.White};
        box-shadow: ${Color.OrangeShadow} 0 0.5rem 2rem 0;
        background-image: linear-gradient(to right, ${Color.Orange5} 0%, ${Color.Orange6} 100%);
  
        &:hover {
          background-image: none;
          background-color: ${Color.Orange5};
        }`;
  }
};
